import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SearchBar = ({ 
  searchTerm, 
  onSearchChange, 
  onSearchSubmit, 
  totalRoles 
}) => {
  const [inputValue, setInputValue] = useState(searchTerm || '');

  const handleInputChange = (e) => {
    const value = e?.target?.value;
    setInputValue(value);
    onSearchChange?.(value);
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    onSearchSubmit?.(inputValue);
  };

  const handleClear = () => {
    setInputValue('');
    onSearchChange?.('');
    onSearchSubmit?.('');
  };

  React.useEffect(() => {
    setInputValue(searchTerm || '');
  }, [searchTerm]);

  return (
    <div className="bg-white bg-opacity-10 backdrop-blur-sm border border-white border-opacity-20 rounded-xl p-6 mb-6">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center space-x-3">
          <div className="w-8 h-8 bg-purple-500 bg-opacity-50 rounded-full flex items-center justify-center">
            <Icon name="Users" size={16} className="text-purple-200" />
          </div>
          <h2 className="text-lg font-heading font-semibold text-white">
            Character Role Search
          </h2>
        </div>
        {totalRoles > 0 && (
          <div className="text-sm text-blue-200 font-caption">
            {totalRoles} character{totalRoles !== 1 ? 's' : ''} available
          </div>
        )}
      </div>

      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="relative">
          <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
            <Icon name="Search" size={20} className="text-blue-200" />
          </div>
          
          <input
            type="text"
            value={inputValue}
            onChange={handleInputChange}
            placeholder="Search by character name, musical, vocal range, or voice type..."
            className="w-full pl-12 pr-20 py-3 bg-white bg-opacity-10 border border-white border-opacity-20 rounded-lg text-white placeholder-blue-200 font-body focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-transparent backdrop-blur-sm"
          />
          
          {inputValue && (
            <button
              type="button"
              onClick={handleClear}
              className="absolute inset-y-0 right-12 flex items-center px-2 text-blue-200 hover:text-white transition-colors duration-200"
              aria-label="Clear search"
            >
              <Icon name="X" size={16} />
            </button>
          )}

          <Button
            type="submit"
            size="sm"
            variant="default"
            className="absolute inset-y-0 right-1 my-1 bg-purple-600 hover:bg-purple-700 text-white rounded-md px-3"
            iconName="Search"
          />
        </div>

        <div className="flex flex-wrap gap-2 text-xs text-blue-200">
          <div className="flex items-center space-x-1">
            <Icon name="Info" size={12} />
            <span className="font-caption">Search examples:</span>
          </div>
          <span className="bg-white bg-opacity-10 px-2 py-1 rounded">Soprano</span>
          <span className="bg-white bg-opacity-10 px-2 py-1 rounded">Lead role</span>
          <span className="bg-white bg-opacity-10 px-2 py-1 rounded">Hamilton</span>
          <span className="bg-white bg-opacity-10 px-2 py-1 rounded">C4-F5</span>
        </div>
      </form>
    </div>
  );
};

export default SearchBar;